import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "slider-label" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "placeholder"
}
const _hoisted_4 = {
  key: 0,
  class: "dropdown-menu"
}
const _hoisted_5 = { class: "slider" }
const _hoisted_6 = ["min", "max"]
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = ["min", "max"]

import { ref, onMounted, onBeforeUnmount, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SliderSelectorComponent',
  props: {
  minValue: {
    type: Number,
    default: 0,
  },
  maxValue: {
    type: Number,
    default: 100,
  },
  unit: {
    type: String,
    default: 'km',
  },
  label: {
    type: String,
    default: 'Label',
  },
  initialValue: {
    type: Number,
    default: 0,
  },
  placeholder: {
    type: String,
    default: '',
  },
  id: {
    type: String,
  },
  modelValue: Number
},
  emits: ['updateSlider', 'update:modelValue'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;
const value = ref<number>(props.modelValue ?? props.initialValue);
const isOpen = ref(false);
const dropdownRef = ref<HTMLElement | null>(null);

// Sincronizar `modelValue` con `value` cuando cambie desde el padre
watch(() => props.modelValue, (newValue) => {
  if (newValue !== undefined) {
    value.value = Math.min(Math.max(newValue, props.minValue), props.maxValue); // Validación
  }
});

// Emitir cambios cuando el usuario mueva el slider o el input
watch(value, (newValue) => {
  const validatedValue = Math.min(Math.max(newValue, props.minValue), props.maxValue);
  if (validatedValue !== newValue) {
    value.value = validatedValue;
  }
  emit("update:modelValue", validatedValue);
  emit("updateSlider", props.id, validatedValue);
});

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const handleClickOutside = (event: MouseEvent) => {
  if (isOpen.value && dropdownRef.value && !dropdownRef.value.contains(event.target as Node)) {
    isOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "distance-selector",
    ref_key: "dropdownRef",
    ref: dropdownRef
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(__props.label), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["dropdown-trigger", { 'is-active': isOpen.value }]),
      onClick: toggleDropdown
    }, [
      (value.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(value.value) + " " + _toDisplayString(__props.unit), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.placeholder), 1)),
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "caret bp-icon-Chevron" }, null, -1))
    ], 2),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              id: "slider",
              type: "range",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
              min: __props.minValue,
              max: __props.maxValue
            }, null, 8, _hoisted_6), [
              [
                _vModelText,
                value.value,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              id: "numericInput",
              type: "number",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
              min: __props.minValue,
              max: __props.maxValue
            }, null, 8, _hoisted_8), [
              [
                _vModelText,
                value.value,
                void 0,
                { number: true }
              ]
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})